<template>
  <CursosIndex />
</template>

<script>
import CursosIndex from "@/components/cursos/CursosIndex.vue";

export default {
  name: "IndexCursos",
  components: {
    CursosIndex
  }
};
</script>
